import script from "./ReleaseAnnouncementHost.vue?vue&type=script&setup=true&lang=js"
export * from "./ReleaseAnnouncementHost.vue?vue&type=script&setup=true&lang=js"

import "./ReleaseAnnouncementHost.vue?vue&type=style&index=0&id=fe533428&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fe533428"]])

export default __exports__